<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div class="alert-container">
	<div id="app-alert" *ngFor="let alert of alerts; let j = index" class="{{ cssClass(alert) }}  alert-dismissable">
		{{ alert.message }}
		<i type="button" class="close" tabindex="0" aria-label="Close" (click)="removeAlert(alert)">
			<span aria-hidden="true">&times;</span>
		</i>
	</div>
</div>
